export var EVENT_KEY;
(function (EVENT_KEY) {
    EVENT_KEY["mark"] = "mark";
    EVENT_KEY["delete"] = "delete";
    EVENT_KEY["removeMark"] = "removeMark";
    EVENT_KEY["mouseenter"] = "mouseenter";
    EVENT_KEY["mouseleave"] = "mouseleave";
})(EVENT_KEY || (EVENT_KEY = {}));
